import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: "Indie Flower", 'Helvetica', sans-serif;
    font-size: 32px;
    background: #fff;
    color: #000;
  }

  a {
    text-decoration: none;
  }
`;

export default GlobalStyle;